import React from "react";

export default class URLInput extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      imageSource: null
    };
  }

  _handleSave(){
    let {
      imageSource
    } = this.state

    if(!imageSource.startsWith("https://")){
      this.setState({error: true})
      return
    }

    this.setState({error: false})

    let linkData = {
      banner: imageSource,
      thumbnail: imageSource,
      original: imageSource,
    }

    this.props.onSave(linkData)
  }

  render() {
    let {
      error,
      imageSource
    } = this.state

    return (
      <div className="url">

        <div class="form-group">
          <div>
            <label>Enter Image URL</label>
            <input
              type="text"
              placeholder="Enter Image Source"
              className="form-control form-control-lg"
              value={imageSource}
              onChange={e => {
                imageSource = e.target.value
                this.setState({imageSource, error: false})
              }}
            />
          </div>
          <button
            className="btn btn--primary"
            onClick={() => this._handleSave()}
          >
            SAVE
          </button>
          {
            error &&
            <p className="text-danger">Please provide a valid https url</p>
          }
          <dl>
            <dt>Important Notice:</dt>
            <dd>The url must begin with https.</dd>
            <dd>The url will be placed on the page exactly as entered. If the image changes at that url then the page will change. If the image is ever removed from that url then the image will be removed from the page.</dd>
            <dd>Use only images that you have control over.</dd>
          </dl>

        </div>



      </div>
    )
  }

}
